import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  title, 
  value, 
  change, 
  changeType, 
  icon, 
  trend = [], 
  onClick,
  className = '' 
}) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div 
      className={`bg-card border border-border rounded-lg p-6 card-shadow hover:shadow-lg transition-smooth cursor-pointer ${className}`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name={icon} size={20} className="text-primary" />
          </div>
          <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
        </div>
        <Icon name="MoreVertical" size={16} className="text-muted-foreground" />
      </div>
      <div className="space-y-2">
        <div className="text-2xl font-bold text-foreground">{value}</div>
        
        {change && (
          <div className={`flex items-center space-x-1 text-sm ${getChangeColor()}`}>
            <Icon name={getChangeIcon()} size={14} />
            <span>{change}</span>
            <span className="text-muted-foreground">vs last month</span>
          </div>
        )}
        
        {trend?.length > 0 && (
          <div className="flex items-center space-x-1 mt-3">
            {trend?.map((point, index) => (
              <div
                key={index}
                className={`w-1 rounded-full ${
                  point > 50 ? 'bg-success h-6' : point > 25 ? 'bg-warning h-4' : 'bg-muted h-2'
                }`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricCard;